<template>
<div class="reset-container animated fadeInUp">
  <v-flex tag="h3">{{$t('view.resetPwd.title')}}</v-flex>
  <v-subheader>{{$t('view.resetPwd.instructions')}}</v-subheader>
  <form role="form" v-on:submit.prevent @keyup.enter="resetPassword">
    <v-text-field 
      prepend-icon="lock" 
      name="password" 
      :disabled="view.action.resetPassword.busy"
      v-model.trim="$v.auth.newpassword.$model"
      :error-messages="$t(`validator.${getFirstError($v.auth.newpassword)}.text`,'')"
      :label="$t('view.resetPwd.password.placeholder')"
      type="password"></v-text-field>
    <!-- <div class="input-group m-b"
      :class="[hasErrors($v.auth.newpassword)?'has-error':'']">
      <span class="input-group-addon signin--i"><i class="icon-append fa fa-lock"></i></span> 
      <input type="password" 
        class="form-control signin--lock"
        v-model="$v.auth.newpassword.$model" 
        :disabled="view.action.resetPassword.busy"
        :placeholder="$t('view.resetPwd.password.placeholder')">
    </div>
    <label class="error--text" for="password"
        v-if="hasErrors($v.auth.newpassword)">
        {{$t(`validator.${getFirstError($v.auth.newpassword)}.text`,"")}}
    </label> -->
    <v-text-field 
      prepend-icon="lock" 
      name="password" 
      :disabled="view.action.resetPassword.busy"
      v-model.trim="$v.auth.confirmpassword.$model"
      :error-messages="$t(`validator.${getFirstError($v.auth.confirmpassword)}.text`,'')"
      :label="$t('view.resetPwd.confirmpassword.placeholder')"
      type="password"></v-text-field>

    <!-- <div class="input-group m-b"
      :class="[hasErrors($v.auth.confirmpassword)?'has-error':'']">
      <span class="input-group-addon signin--i"><i class="icon-append fa fa-lock"></i></span> 		
      <input type="password" 
        class="form-control signin--lock"
        v-model="$v.auth.confirmpassword.$model" 
        :disabled="view.action.resetPassword.busy"
        :placeholder="$t('view.resetPwd.confirmpassword.placeholder')">
    </div> -->
    <label class="error--text" for="password"
      v-if="hasErrors($v.auth.confirmpassword)">
      {{getConfirmPasswordErrorDescription}}
    </label>
    <div class="form-group">
      <label class="error--text" 
        v-if="view.elem.label.resetPasswordError.visible">
        {{errorResetPasswordMessage}}
      </label>
      <v-btn 
        :disabled="hasErrors($v.auth) || view.action.resetPassword.busy" 
        name="loginSubmit"
        @click="resetPassword()"
        block 
        color="primary">
          {{$t('view.resetPwd.submit')}}
      </v-btn>
      <!-- <button type="button"
        class="btn btn-primary block full-width signin--ingresar" 
        :disabled="hasErrors($v.auth) || view.action.resetPassword.busy"
        @click="resetPassword()" >
        <strong>{{$t('view.resetPwd.submit')}}</strong>
      </button> -->
    </div>
  </form>
</div>
</template>
<script>
import Auth from "@/services/auth";
import transform from "@/helpers/transformations";
import * as actions from "@/constants/mutation-names";
import {valueIsWithin} from "@/helpers/validators";
import {AuthenticationModel} from "@/models/authentication";
import {allValidatorMethods} from "@/helpers/vuelidate";
import {errors} from "@/locales/languages/es_MX";
import {required, minLength, sameAs} from "vuelidate/lib/validators";

// List of errors required for changing password flow
const errorsResetPassword = Object.keys(errors.resetPassword);
const errorsChangePassword = Object.keys(errors.changePassword);
//Element's Settings
const label = {
  resetPasswordError:{
    visible:false
    , text : ""
  }
};
const button = {
  resetPassword:{
    enable:true
  }
};
//Action's state
const action = {
  resetPassword:{
    busy:false
  }
};
export default {
  name: "ResetPassword",
  head: {
    title: function() {
      return {
        inner       : this.view.title
        , separator : '|'
        , complement: this.$t("view.home.system.initials")
      };
    }
  },
  data() {
    return {
      auth:undefined
      , locale: this.$i18n.locale
      , token: undefined
      , view : {
        title: "Restablecer Contraseña"
        , action
        , elem:{
          label
          , button
        }
      }
    };
  }
  , methods:{
    ...allValidatorMethods
    ,  async resetPassword(){
      try{
        // Hide any previous error
        this.hideErrorResetPassword();
        // Validate all models before make the request
        if(!this.isAllValid(this.$v)){
          return;
        }
        //Gettin data to submit
        const {newpassword, confirmpassword} = this.auth;
        const {token} = this;
        this.view.action.resetPassword.busy=true;
        const response = await Auth.resetPassword({newpassword, confirmpassword, token});
        this.view.action.resetPassword.busy=false;
        // Gettin data from response
        let {data:{results:{token:userToken, usuario, roles}}} = response;
        const data = {...transform.ResponseToUserStore(usuario), userToken, roles};
        this.$store.dispatch(actions.AUTH_LOGIN,data);
        this.$userPermission.set({roles});
        this.$router.push("/home");
      }catch(error){
        this.view.action.resetPassword.busy=false;

        if(error && (error.status=="500" || error.status=="504")){
          this.showErrorResetPassword(this.$t(`network.errors.${error.status}.desc`));
          return;
        }

        const {data:{meta:{code:errorCode}}} = error; 
        // Error's reseting password        
        if(valueIsWithin(errorsResetPassword,errorCode))
          this.showErrorResetPassword(this.$t(`errors.resetPassword.${errorCode}.text`));  
        // Error's reseting password        
        if(valueIsWithin(errorsChangePassword,errorCode))
          this.showErrorResetPassword(this.$t(`errors.changePassword.${errorCode}.text`));  
      }
    }
    , showErrorResetPassword(message){
      this.view.elem.label.resetPasswordError.visible=true;
      this.view.elem.label.resetPasswordError.text = message;
    }
    , hideErrorResetPassword(){
      if(!this.view.elem.label.resetPasswordError.visible)
        return;
      this.view.elem.label.resetPasswordError.visible=false;
      this.view.elem.label.resetPasswordError.text="";
    }
    , setInitialState(){
      this.auth = new AuthenticationModel();
      this.view.elem.label.resetPasswordError.visible=false;
      this.view.elem.label.resetPasswordError.text=""
      document.querySelector('#imageLogo').style.height = "0vh";
    }
  }
  , computed:{
    errorResetPasswordMessage(){
      return this.view.elem.label.resetPasswordError.text
    }
    , getConfirmPasswordErrorDescription(){
      const sameAs = (parameters)=>{
        return "Ambas contraseñas deben coincidir"
      }
      return this.getFirstErrorDescription(this.$v.auth.confirmpassword,{sameAs})
    }
  }
  , validations:{
    auth:{
      newpassword:{
        required
      }
      , confirmpassword:{
        required
        , sameAs: sameAs('newpassword')
      }
    }
  }
  , components:{

  }
  ,created(){
    if(this.$route.query.token){
      this.token = this.$route.query.token;
      this.setInitialState()
    }else{
      this.$router.push("/401Unauthorized")
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.reset-container{
  position:relative;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/authentication/ResetPassword.vue